import request from '@/utils/request'
//get
export function getOpportunityByParam(param) {
    return request({
        url: `/opportunity/${param}`,
        method: 'GET'
    })
}

export function updateOpportunity(id,data) {
  return request({
      url: `/opportunity/${id}/`,
      method: 'PATCH',
      data
  })
}
//get
export function getTrail_log(param) {
    return request({
        url: `/trail_log/${param}`,
        method: 'GET'
    })
}

//get
export function getCooperate(param) {
    return request({
        url: `/cooperate/${param}`,
        method: 'GET'
    })
}

export function updateCooperate(id,data) {
  return request({
      url: `/cooperate/${id}/`,
      method: 'PATCH',
      data
  })
}
// update
export function updateTrail(id,data) {
  return request({
      url: `/trail_log/${id}/`,
      method: 'PATCH',
      data
  })
}



// WEBPACK FOOTER //
// ./src/api/opportunity.js